import React from 'react';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';

interface ClickableUserNameProps {
  userId: string;
  displayName: string;
  className?: string;
  showIcon?: boolean;
  fallbackText?: string;
}

export function ClickableUserName({
  userId,
  displayName,
  className = "text-blue-600 hover:text-blue-800 hover:underline cursor-pointer",
  showIcon = false,
  fallbackText = "Unknown User"
}: ClickableUserNameProps) {
  const displayText = displayName || fallbackText;

  return (
    <Link
      to={`/admin/users/${userId}`}
      className={className}
      title={`View profile for ${displayText}`}
    >
      {showIcon && <User className="w-4 h-4 inline mr-1" />}
      {displayText}
    </Link>
  );
}
